import CommonStyles from 'common/CommonStyles';

const { ScaleStyle, Scaledp } = CommonStyles;
const computedFn = (styles) => {
  return ScaleStyle(styles);
};
computedFn.Scaledp = Scaledp;

const wrapStyle = (obj) => {
  let viewHeight = CommonStyles.viewHeight;
  let viewWidth = CommonStyles.viewWidth;
  let changedObject;
  return new Proxy(obj, {
    get: function (target, key, receiver) {
      if (!changedObject || !(CommonStyles.ViewHeight === viewHeight && CommonStyles.ViewWidth === viewWidth)) {
        changedObject = computedFn(obj);
        viewHeight = CommonStyles.ViewHeight;
        viewWidth = CommonStyles.ViewWidth;
      }
      return changedObject[key];
    },
  });
};
export { wrapStyle };
export default computedFn;
